import { render, staticRenderFns } from "./zhyj.vue?vue&type=template&id=9d058cba&scoped=true&"
import script from "./zhyj.vue?vue&type=script&lang=js&"
export * from "./zhyj.vue?vue&type=script&lang=js&"
import style0 from "./zhyj.vue?vue&type=style&index=0&id=9d058cba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d058cba",
  null
  
)

export default component.exports